import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { VoucherListByHotelID_TopPage_Query } from "@/components/features/marketing/voucher/_shared/repository/query/schema";
import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { VoucherDelete_TopPage_Mutation } from "./mutation";

export const useVoucherDelete = () => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(VoucherDelete_TopPage_Mutation, {});

	const onDeleteVoucher = useCallback(
		(
			hotelID: string, //
			voucherID: string,
			voucherName: string,
		) => {
			showLoadingScreenCallback();

			mutationFunc({
				variables: {
					hotelID,
					voucherID,
				},
				refetchQueries: [
					{
						query: VoucherListByHotelID_TopPage_Query,
						variables: {
							hotelID,
						},
					},
				],
			})
				.then(({ errors }) => {
					if (!errors) {
						notifyUserEventInfo({
							variant: "default",
							title: `宿泊券(${voucherName})を削除しました`,
						});
					}
				})
				.finally(() => {
					hideLoadingScreenCallback();
				});
		},
		[hideLoadingScreenCallback, mutationFunc, showLoadingScreenCallback],
	);

	return {
		onDeleteVoucher,
	};
};
